module.exports = __webpack_public_path__ + "img/text-mark8.0848cc86.png";